var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './reset-button.shape';
import { listen, attr, boolAttr } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPPluginButton } from '../../core/button/plugin-button';
/** Button-plugin to reset snippet to default settings */
export class UIPReset extends UIPPluginButton {
    onAction() {
        var _a;
        (_a = this.$root) === null || _a === void 0 ? void 0 : _a.storage.resetState(this.source);
    }
    _onModelChange() {
        if (!this.model || !this.model.activeSnippet)
            return;
        if (this.source === 'js')
            this.disabled = !this.model.isJSChanged();
        if (this.source === 'html')
            this.disabled = !this.model.isHTMLChanged();
    }
}
UIPReset.is = 'uip-reset';
__decorate([
    boolAttr()
], UIPReset.prototype, "disabled", void 0);
__decorate([
    attr({ defaultValue: 'html' })
], UIPReset.prototype, "source", void 0);
__decorate([
    listen({ event: 'uip:model:change', target: ($this) => $this.model })
], UIPReset.prototype, "_onModelChange", null);
